<template>
    <v-row justify="center">
        <v-dialog v-model="dialogDetails" persistent transition="dialog-bottom-transition">
            <v-card class="elevation-4">

                <!-- Title -->
                <v-toolbar dark color="primary">
                    <v-btn icon dark @click.native="handleModalDetails">
                        <v-icon>fas fa-times-circle</v-icon>
                    </v-btn>

                    <v-toolbar-title>
                        <div class="text-h6 font-weight-bold white--text">
                            Detalles del {{ rayaSelected?.fechaInicio }} al {{ rayaSelected?.fechaFin }}
                        </div>
                    </v-toolbar-title>
                </v-toolbar>

                <!-- Search -->
                <v-card-title>
                    <v-spacer></v-spacer>

                    <v-col cols="12" md="6" sm="4" class="d-flex justify-end">
                        <v-text-field v-model="search" append-icon="fas fa-search"
                        label="Buscar por nombre del empleado" single-inline hide-details
                        @keydown.enter="searchRaya">
                        </v-text-field>
                        <v-btn icon class="mt-4 ml-2">
                            <v-icon dense>fas fa-sync</v-icon>
                        </v-btn>
                    </v-col>
                </v-card-title>

                <!-- Table -->
                <v-card-text>
                    <v-data-table dense :headers="headers" :items="detailsList" sort-by="idRaya" class="elevation-1" 
                    :server-items-length="totalElements" :items-per-page="itemsPerPage"
                    :page.sync="page" @page-count="totalPages = $event" 
                    hide-default-footer>

                        <template v-slot:[`item.estatus`]="{ item }">
                            <v-chip class="white--text text--lighten-4 text-h7" :color="item.estatus == 'PAID' ? 'green' : 'red'"
                                small dense filled label> {{ item.estatus == 'PAID' ? 'Pagado' : 'Por pagar' }}
                            </v-chip>
                        </template>

                        <template v-slot:[`item.actions`]="{ item }">
                            <v-menu bottom offset-x rounded="lg" transition="slide-y-transition" color="primary">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon v-bind="attrs" v-on="on" color="teal darken-1" class="white--text" small>
                                        <v-icon>fas fa-ellipsis-v</v-icon>
                                    </v-btn>
                                </template>
                                <v-list dense>
                                    <v-list-item disabled>
                                        <v-list-item-content>
                                            <v-list-item-subtitle>Empleado: {{ item.empleado.nombreCompleto }}</v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item @click.prevent="downloadDetail(item)">
                                        <v-list-item-title>
                                            <v-icon small class="mr-2">fas fa-file-excel</v-icon> Descargar excel
                                        </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click.prevent="previewPDF({ isWithPrinter : true, rayaDetalleId : item.id })">
                                        <v-list-item-title>
                                            <v-icon small class="mr-2">fas fa-file-pdf</v-icon> Imprimir detalle en ticket
                                        </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click.prevent="previewPDF({ isWithPrinter : false, rayaDetalleId : item.id })">
                                        <v-list-item-title>
                                            <v-icon small class="mr-2">fas fa-file-pdf</v-icon> Imprimir detalle
                                        </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click.prevent="showPayment(item)" v-if="!item.fechaPago">
                                        <v-list-item-title class="green--text">
                                            <v-icon small class="mr-2 green--text">fas fa-money-bill-1</v-icon> Registrar pago
                                        </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click.prevent="cancelPayment(item)" v-if="item.estatus == 'PAID'">
                                        <v-list-item-title class="red--text">
                                            <v-icon small class="mr-2 red--text">fas fa-ban</v-icon> Cancelar pago
                                        </v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </template>

                    </v-data-table>
                </v-card-text>

                <!-- Pagination -->
                <v-card-actions>
                    <PaginationNumber :itemsPerPage.sync="itemsPerPage" :pageCount.sync="totalPages"
                    :totalElements.sync="totalElements" :page.sync="page" :initialize.sync="initialize" />
                </v-card-actions>

            </v-card>
        </v-dialog>
        <PaymentRaya :dialog="dialogPayment" :handleModalPayment="handleModalPayment"
        :rayaDetalle="rayaDetalle" :raya="rayaSelected" :initialize="initialize"
        v-if="dialogPayment">
        </PaymentRaya>
        <PreviewPDF :pdfSource="pdfSource" :pdfBlob="pdfBlob" :title-pdf="titlePdf"
            :handlePdfModal="handlePdfModal" :dialog="showPdf" v-if="showPdf">
        </PreviewPDF>
    </v-row>
</template>

<script>
import { getParamsPagination } from '@/utils/pagination';
import PaginationNumber from '@/components/shared/PaginationNumber.vue';
import RayaDetalleDataService from '@/service/raya/RayaDetalleDataService';
import PreviewPDF from '@/components/shared/PreviewPDF.vue';
import { showConfirmAlert, showErrorAlert, showSuccessAlert } from '@/helpers/swalHelper';
import PaymentRaya from './PaymentRaya.vue';

    export default {
        name: "MostrarDetalles",
        props: {
            dialogDetails: { type: Boolean, default: false },
            handleModalDetails: { type: Function },
            rayaSelected: { type: Object, default: {} },
        },
        components: { PaginationNumber, PreviewPDF, PaymentRaya },
        created() {
            this.initialize();
        },
        data() {
            return {
                headers: [
                    { text: "Detalle", value: "actions", sortable: false },
                    { text: "id", align: " d-none", sortable: false, value: "id", visible: false },
                    { text: "Empleado", value: "empleado.nombreCompleto", sortable: false },
                    { text: "Salario diario", value: "salarioDiario", sortable: false },
                    { text: "Dias trabajados", value: "diasTrabajados", sortable: false },
                    { text: "Bonos", value: "bonos", sortable: false },
                    { text: "Deducciones", value: "deducciones", sortable: false },
                    { text: "Neto a pagar", value: "netoPagar", sortable: false },
                    { text: "Comentarios", value: "comentarios", sortable: false },
                    { text: "Estatus", value: "estatus", sortable: false },
                    { text: "Fecha de pago", value: "fechaPago", sortable: false },
                ],
                search: "",
                page: 1,
                totalPages: 0,
                itemsPerPage: 25,
                totalElements: 0,

                detailsList: [],
                dialogPayment: false,
                rayaDetalle: {},
                // PDF
                showPdf: false,
                pdfSource: null,
                pdfBlob: null,
                titlePdf: null,
            }
        },
        methods: {
            // Download Methods
            downloadDetail( item ) {
                RayaDetalleDataService.downloadRayaDetallesExcelById(item.id)
                .then(resp => {
                    const url = window.URL.createObjectURL(new Blob([resp.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `lista_de_raya_${ item.empleado.nombre }_del_${ this.rayaSelected.fechaInicio }_al_${ this.rayaSelected.fechaFin }.xlsx`);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                })
                .catch(err => {
                    showErrorAlert({ title: 'Error al obtener los datos', text: err.response.data });
                });
            },
            searchRaya() {
                this.page = 1;
                this.initialize({ page: this.page, itemsPerPage: this.itemsPerPage });
            },
            initialize( options = {} ) {
                const params = getParamsPagination({ options, search: this.search });
                this.itemsPerPage = options.itemsPerPage;

                RayaDetalleDataService.tableByRaya(this.rayaSelected.id, params).then( ({ data }) => {
                    const { rows, totalElements, totalPages, currentPage } = data;
                    this.detailsList = rows;
                    this.totalElements = totalElements;
                    this.page = currentPage + 1 ;
                    this.totalPages = totalPages;
                }).catch( err => {
                    console.log({ err });
                    showErrorAlert({ title: 'Error al obtener los datos', text: err?.response?.data });
                });
            },
            cancelPayment(item){
                showConfirmAlert({ title: 'Cancelar pago', text: `¿Desea cancelar el pago de ${item.empleado.nombreCompleto}?` })
                .then((result) => {
                    if (result.isConfirmed) {
                        RayaDetalleDataService.cancelPayment(item.id).then(_ => {
                            this.initialize();
                            showSuccessAlert({ title: 'Pago cancelado', text: _?.response?.data || 'Pago cancelado exitosamente' });
                        }).catch(err => {
                            showErrorAlert({ title: 'Error al cancelar el pago', text: err?.response?.data });
                        });
                    }
                });
            },
            showPayment(item){
                this.rayaDetalle = item
                this.dialogPayment = true
            },
            handleModalPayment() {
                this.dialogPayment = false
            },
            previewPDF({ isWithPrinter = false, rayaDetalleId = 0, titlePdf = 'Raya' }) {
                const params = { isWithPrinter, rayaDetalleId };
                this.titlePdf = titlePdf
                RayaDetalleDataService.downloadRayaDetallePdf(params).then( response => {
                    this.pdfBlob = new Blob([response.data], { type: 'application/pdf' })
                    this.pdfSource = URL.createObjectURL(this.pdfBlob)
                    this.showPdf = true
                }).catch( error => {
                    showErrorAlert({ title: 'Error al generar el reporte', text: error?.response?.data });
                });
            },
            handlePdfModal() {
                this.showPdf = !this.showPdf
                this.cleanupPdf()
            },
            cleanupPdf() {
                if(this.pdfSource){
                    URL.revokeObjectURL(this.pdfSource)
                    this.pdfSource = null
                }
                this.pdfBlob = null
            }
        }
    }
</script>
